export default "__VITE_ASSET__2d04ca23__"